import type { FreelancerLoginLocales } from '../types';

const freelancerLoginLocales: FreelancerLoginLocales = {
  loginError: 'Login Error',
  loginSuccess: 'You are logged in!',
  passwordForgotten: 'Password Forgotten',
  title: 'Login',
};

export default freelancerLoginLocales;
